(() => {
  if (window.__nnCountryCardCopyLoaded) return;
  window.__nnCountryCardCopyLoaded = true;

  const copy = {
    england: ['England', 'Where heritage and new journeys meet.'],
    scotland: ['Scotland', 'For wild horizons and stories held close.'],
    wales: ['Wales', 'Where ancient valleys keep their legends.'],
    ireland: ['Ireland', 'For emerald roads and a warm welcome.'],
    'united-states': ['United States', 'For dreams measured in open roads.'],
    canada: ['Canada', 'Where wilderness and wonder stretch forever.'],
    mexico: ['Mexico', 'Where colour, spirit and memory live brightly.'],
    'dominican-republic': ['Dominican Republic', 'For sunlit shores and joy without measure.'],
    brazil: ['Brazil', 'Where rhythm, colour and wild beauty meet.'],
    'south-africa': ['South Africa', 'Where two oceans meet a world of wonder.'],
    'united-arab-emirates': ['United Arab Emirates', 'Where desert light meets bold horizons.'],
    thailand: ['Thailand', 'For golden temples and barefoot escapes.'],
    japan: ['Japan', 'Where ancient grace meets tomorrow.'],
    australia: ['Australia', 'For sunlit coastlines and boundless horizons.'],
    egypt: ['Egypt', 'Where ancient wonders outlast time.'],
    barbados: ['Barbados', 'For island light and unforgettable warmth.'],
    morocco: ['Morocco', 'Where spice, colour and old-world wonder meet.'],
    malta: ['Malta', 'Where golden stone meets Mediterranean blue.'],
    austria: ['Austria', 'For alpine beauty and timeless elegance.'],
    germany: ['Germany', 'Where heritage, craft and modern spirit meet.'],
    netherlands: ['Netherlands', 'For canal light, open skies and quiet beauty.'],
    norway: ['Norway', 'Where northern light meets untamed beauty.'],
    croatia: ['Croatia', 'Where Adriatic blue meets ancient stone.'],
    turkey: ['Turkey', 'Where continents meet and stories endure.'],
    greece: ['Greece', 'For whitewashed shores and myths beneath the sun.'],
    portugal: ['Portugal', 'Where Atlantic light carries every story home.'],
    italy: ['Italy', 'For memories shaped by beauty and warmth.'],
    france: ['France', 'For beauty found in every lingering moment.'],
    cyprus: ['Cyprus', 'Where golden shores hold ancient stories.']
  };

  const productHandle = (card) => {
    const link = card.querySelector(
      'a[ref="productTitleLink"][href*="/products/"], a[ref="cardGalleryLink"][href*="/products/"]'
    );
    const match = link?.getAttribute('href')?.match(/\/products\/([^?/#]+)/);
    return match?.[1] || '';
  };

  const refine = () => {
    document.querySelectorAll('product-card.nn-charm-card').forEach((card) => {
      const details = copy[productHandle(card)];
      if (!details) return;

      const heading = card.querySelector(
        '.product-card__content > a[ref="productTitleLink"] [role="heading"]'
      );
      const line = card.querySelector('.product-card__content > .nn-card-colour-name');
      if (heading) heading.textContent = details[0];
      if (line) {
        line.textContent = details[1];
        line.classList.add('nn-country-card__line');
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refine, { once: true });
  } else {
    refine();
  }

  [700, 1800, 3400].forEach((delay) => window.setTimeout(refine, delay));
  document.addEventListener('shopify:section:load', refine);
})();
